export default "__VITE_ASSET__446d58c2__"